import React from 'react';

/**
 * Inline SVG icons. Replaces Font Awesome + Flaticon icon fonts
 * (~500 KB of webfonts) with a few hundred bytes of markup.
 */

const base = {
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
};

export const ArrowRight = ({ size = 16, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const ArrowUp = ({ size = 18, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <path d="M12 19V5M6 11l6-6 6 6" />
  </svg>
);

export const ChevronDown = ({ size = 14, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const Phone = ({ size = 16, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export const Mail = ({ size = 16, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m2 7 10 6 10-6" />
  </svg>
);

export const MapPin = ({ size = 16, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const Check = ({ size = 18, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" strokeWidth="2" {...rest}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const Instagram = ({ size = 18, ...rest }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const Facebook = ({ size = 18, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.33-.04-1.55-.14-2.84-.14C12 2 10.5 3.66 10.5 6.7v2.8H8v4h2.5V22h3.5v-8.5z" />
  </svg>
);

export const Linkedin = ({ size = 18, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3V9zm6 0h3.8v1.71h.05c.53-.95 1.83-1.96 3.76-1.96C20.7 8.75 22 11 22 14.24V21h-4v-6.06c0-1.45-.03-3.31-2.06-3.31-2.06 0-2.38 1.58-2.38 3.2V21H9V9z" />
  </svg>
);

export const socialIcons = {
  instagram: Instagram,
  facebook: Facebook,
  linkedin: Linkedin,
};
